import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "authorization";
  const params = ["page", "limit"];

  $stateProvider.state("authorization", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: "<authorization-page></authorization-page>",
      },
    },
    reloadOnSearch: false,
    data: { title: "Authorization" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/authorization/authorization.urls.js